/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { RepatriationOpportunityQuoteStatusResource } from './';
import {
    RepatriationOpportunityQuoteStatusResourceFromJSON,
    RepatriationOpportunityQuoteStatusResourceFromJSONTyped,
    RepatriationOpportunityQuoteStatusResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityQuoteResource
 */
export interface RepatriationOpportunityQuoteResource {
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityQuoteResource
     */
    id: string;
    /**
     * 
     * @type {RepatriationOpportunityQuoteStatusResource}
     * @memberof RepatriationOpportunityQuoteResource
     */
    status: RepatriationOpportunityQuoteStatusResource;
}

/**
 * Check if a given object implements the RepatriationOpportunityQuoteResource interface.
 */
export function instanceOfRepatriationOpportunityQuoteResource(value: object): value is RepatriationOpportunityQuoteResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityQuoteResourceFromJSON(json: any): RepatriationOpportunityQuoteResource {
    return RepatriationOpportunityQuoteResourceFromJSONTyped(json, false);
}

export function RepatriationOpportunityQuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityQuoteResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': RepatriationOpportunityQuoteStatusResourceFromJSON(json['status']),
    };
}

export function RepatriationOpportunityQuoteResourceToJSON(value?: RepatriationOpportunityQuoteResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'status': RepatriationOpportunityQuoteStatusResourceToJSON(value['status']),
    };
}

